import * as React from "react";
import Dropzone from "react-dropzone";
import Img from "react-image";
import VisibilitySensor from "react-visibility-sensor";

import { error, success } from "./Alert";

import def from "../../img/default-user-icon.png";
import { UserAPI } from "../../API";

interface IUserImageProps {
  userId: number;
  schoolId: number;
  height: number|string;
  width: number|string;
  size: string;
  useSensor?: boolean;
}

interface IUserImageState {
  loading: boolean;
  loadTime: any;
  getElement?: any;
}

class UserImage extends React.Component<IUserImageProps, IUserImageState> {

  constructor(props: any) {
    super(props);
    this.state = {
      loadTime: new Date(), // cache busting,
      loading: false,
      getElement: null
    };
    this.getImage = this.getImage.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
  }

  public render() {
    if(this.state.loading || !this.props.userId){
      return (<div className="glyphicon glyphicon-repeat normal-right-spinner" style={{textAlign: "center", width: "100%"}} />);
    }
    
    if(!this.props.useSensor){
      // just return the drop zone
      return this.renderDropzone();
    }
    const containmentDOMRect = this.state.getElement
      ? this.state.getElement
      : null;

    return ( 
      <VisibilitySensor key={`image-${this.props.userId}`} containment={containmentDOMRect} partial={false}>
        {(isVisible: any, rect: any) => {
          if(isVisible.isVisible){
          return this.renderDropzone();
        } else {
          return (<div style={{width: this.props.width, height: this.props.height}} />);
        }
      }}
      </VisibilitySensor>
    );
  }

  private renderDropzone(){
    const im = this.getImage();
    return ((
    <Dropzone onDrop={this.handleDrop} maxSize={5 * 1024 * 1024}>
      {({getRootProps, getInputProps}) => {
        return (
          <div
            {...getRootProps()}
            className="dropzone"
            style={{"textAlign": "center"}}>
            <input {...getInputProps()} />
            <Img 
              width={this.props.width}
              height={this.props.height}
              loader={<div className="glyphicon glyphicon-repeat normal-right-spinner" style={{textAlign: "center", width: "100%"}} />}
              src={[im, def]} 
              unloader={(<img src="/img/default-user-icon.png" height={this.props.height} width={this.props.width} />)}/>
          </div>
        );
      }
      }
    </Dropzone>));
  }

  private async handleDrop(acceptedFiles: any) {
    this.setState({loading: true}, async () => {
      try{
        await UserAPI.uploadUserProfileImage(this.props.schoolId, this.props.userId, acceptedFiles[0]);
        return this.setState({ loadTime: new Date(), loading: false}, () => {
          return success("Profile image updated! It may take a few minutes for the new image to appear throughout the application.");
        });
      }catch(err){
        return this.setState({loading: false}, () => {
          return error("Could not save that image");
        });
      }
    });
  }

  private getImage() {
    const asThumb = this.props.size === "small" || this.props.size === "thumb" ? true : false;
    return UserAPI.getUserProfileImageString(this.props.schoolId, this.props.userId, asThumb, true);
  }
}


export default UserImage;